module.exports = __webpack_public_path__ + "static/media/add_multiple_agents.78cbfb13.svg";